import React, { useEffect, useState } from 'react'
import { compose } from 'recompose'
import { ConnectedProps, connect } from 'react-redux'

import { RootState } from 'core/reducers'

import { Administration, EmergencyDose } from 'services/administrations/models'

import { withAppService, withAppServiceProps } from 'services/app'
import { withAdministrationsService, withAdministrationsServiceProps } from 'services/administrations'
import { withModalService, withModalServiceProps } from 'services/utils/modal'
import { withUploadService, withUploadServiceProps } from 'services/legacy/upload'
import { withRouter, withRouterProps } from 'services/router'

import PreviewView from './PreviewView'

const ADMINISTRATION_GROUPS = {
  read: [
    'administration',
    'administration.medicationForm',
    'administration.medicationDetails',
    'administration.contactedParent',
    'administration.child',
    'administration.signatures',
    'administrationSignature',
    'administrationSignature.owner',
    'administrationSignature.carer',
    'administrationSignature.signature',
    'medicationForm',
    'medicationForm.medicationDetails',
    'medicationForm:medicationDetails',
    'medicationDetails',
    'medicationForm.child',
    'medium',
    'user',
    'child',
    'carer',
    'membership',
  ],
}

type PreviewContainerProps =
  & withAppServiceProps
  & withAdministrationsServiceProps
  & withModalServiceProps
  & withRouterProps
  & withUploadServiceProps

const mapState = (state: RootState, {
  administrationsSingleState,
  appSelectors,
}: PreviewContainerProps) => ({
  errorMessages: appSelectors.getErrorMessages(administrationsSingleState),
  isFetching: appSelectors.getIsFetching(administrationsSingleState),
})

const connector = connect(mapState)

type PropsFromRedux = ConnectedProps<typeof connector>

const PreviewContainer: React.FC<PreviewContainerProps & PropsFromRedux> = ({
  administrationsActions,
  errorMessages,
  isFetching,
  params,
}) => {
  const { id: medicationFormId } = params || {}
  const [administrations, setAdministrations] = useState<Administration & EmergencyDose>()

  useEffect(() => {
    if (medicationFormId) {
      administrationsActions.get({
        onSuccess: ({ data }) => setAdministrations(data),
        params: [medicationFormId, {
          groups: ADMINISTRATION_GROUPS,
        }],
      })
    }

    return () => {
      administrationsActions.clear()
    }
  }, [])

  return (
    <PreviewView
      administrations={administrations}
      errorMessages={errorMessages}
      isLoading={isFetching}
    />
  )
}

const enhance = compose(
  withAppService,
  withAdministrationsService,
  withModalService,
  withUploadService,
  withRouter,
  connector,
)

export default enhance(PreviewContainer)
